import React, { Component } from 'react';
import { Card, Col, message, Row, Table } from 'antd';
import util from '@util';
import { queryBudgetGroupAims } from '@api/finance/budget';
import DescriptionList from '@comm/DescriptionList';
import { queryDictExpend, queryDictIncome } from '@api/core/dict';

const { Description } = DescriptionList;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      groupName: '',
      year: '',
      sumAimData: {},
      expendType: [],
      incomeType: [],
    };
  }

  componentWillMount() {
    this.loadBudgetExpendType();
    this.loadDictIncome();
  }

  componentWillReceiveProps(nextProps) {
    const detail = nextProps.data.detail || {
      BUSINESS_COSTS: [],
      BUSINESS_POOL: [],
      FIXED_POOL: [],
      LABOR_COSTS: [],
      SUM: {
        SUM: 0,
        flag: 5,
        sum: 0,
      },
    };
    this.setState({
      isLoading: true,
    });
    let data = [];
    data = data.concat(detail.LABOR_COSTS);
    data = data.concat(detail.BUSINESS_COSTS);
    data = data.concat(detail.FIXED_POOL);
    data = data.concat(detail.BUSINESS_POOL);

    detail.SUM.flag = 5;
    if (data.length > 0) {
      data = data.concat(detail.SUM);
    }
    this.setState({
      sum: detail.SUM.SUM,
      data,
      isLoading: false,
      groupName: nextProps.data.groupName,
      year: nextProps.data.year,
      busCosLen: detail.BUSINESS_COSTS.length,
      busPoolLen: detail.BUSINESS_POOL.length,
      fixedLen: detail.FIXED_POOL.length,
      laborLen: detail.LABOR_COSTS.length,
    });

    this.getBudgetGroupAims({
      groupUuid: nextProps.data.groupUuid,
      year: nextProps.data.year,
    });
  }

  // 获得支出资金类型
  loadBudgetExpendType = () => {
    queryDictExpend().then(res => {
      if (res.statusCode === 200) {
        this.setState({
          expendType: res.data,
        });
      }
    });
  };

  // 获得收入资金类型
  loadDictIncome = () => {
    queryDictIncome().then(res => {
      if (res.statusCode === 200) {
        this.setState({
          incomeType: res.data,
        });
      }
    });
  };

  // 获得目标收入
  getBudgetGroupAims = params => {
    queryBudgetGroupAims(params).then(res => {
      if (res.statusCode === 200) {
        if (res.data) {
          this.setState({
            sumAimData: res.data,
          });
        }
      } else {
        message.error(res.message);
      }
    });
  };

  findTypes = typesArr => {
    const { incomeType } = this.state;
    const sameItem = incomeType.filter(item => {
      return typesArr.indexOf(item.value) !== -1;
    });
    let str = '';
    sameItem.map(item => {
      str += `${item.key},`;
      return item;
    });
    str = str.slice(0, -1);
    return str;
  };

  columns = () => {
    const config = [];
    const { data, busCosLen, busPoolLen, fixedLen, laborLen } = this.state;
    for (let i = 1; i <= 12; i++) {
      const item = {};
      const key = i < 10 ? `0${i}` : `${i}`;
      item.title = i < 10 ? `0${i}` : `${i}`;
      item.dataIndex = key;
      item.key = key;
      item.width = 100;
      item.render = text => {
        const money = util.numberFormat(text, 2, '.', ',');
        return <span>{money === '0.00' ? '' : money}</span>;
      };
      config.push(item);
    }
    config.unshift({
      title: '合计',
      dataIndex: 'sum',
      key: 'sum',
      width: 150,
      render: text => {
        const money = util.numberFormat(text, 2, '.', ',');
        return <span>{money === '0.00' ? '' : money}</span>;
      },
    });
    config.unshift({
      title: '费用科目',
      dataIndex: 'type',
      key: 'type',
      width: 150,
      render: (text, record, index) => {
        const obj = {
          children: <span>{this.matchType(text)}</span>,
          props: {},
        };
        if (index === data.length - 1) {
          obj.props.colSpan = 0;
        }
        return obj;
      },
    });
    config.unshift({
      title: '二级科目',
      dataIndex: 'sub',
      key: 'sub',
      width: 150,
      render: (text, record, index) => {
        let sub = '';
        if (record.flag === 1) {
          sub = '人力成本';
        } else if (record.flag === 2) {
          sub = '业务成本';
        } else if (record.flag === 3) {
          sub = '固定公摊';
        } else if (record.flag === 4) {
          sub = '业务公摊';
        } else if (record.flag === 5) {
          sub = '合计';
        }
        const obj = {
          children: <span>{sub}</span>,
          props: {},
        };
        if (laborLen !== 0 && index === 0) {
          obj.props.rowSpan = laborLen; // 合并业务公摊
        } else if (index > 0 && index < laborLen) {
          obj.props.rowSpan = 0;
        } else if (busCosLen !== 0 && index === laborLen) {
          obj.props.rowSpan = busCosLen; // 合并业务成本
        } else if (index > laborLen && index < laborLen + busCosLen) {
          obj.props.rowSpan = 0;
        } else if (fixedLen !== 0 && index === laborLen + busCosLen) {
          obj.props.rowSpan = fixedLen; // 合并固定公摊
        } else if (
          busCosLen !== 0 &&
          index > laborLen + busCosLen &&
          index < laborLen + busCosLen + fixedLen
        ) {
          obj.props.rowSpan = 0;
        } else if (busPoolLen !== 0 && index === fixedLen + busCosLen + laborLen) {
          obj.props.rowSpan = busPoolLen;
        } else if (
          index > busPoolLen + busCosLen + laborLen &&
          index < busPoolLen + busCosLen + fixedLen + laborLen
        ) {
          obj.props.rowSpan = 0;
        } else {
          obj.props.colSpan = 2;
        }
        return obj;
      },
    });
    config.unshift({
      title: '一级科目',
      dataIndex: 'main',
      key: 'main',
      width: 150,
      render: (text, record, index) => {
        const obj = {
          children: <span>运营成本</span>,
          props: {},
        };
        if (index === 0) {
          obj.props.rowSpan = data.length;
        } else {
          obj.props.rowSpan = 0;
        }
        return obj;
      },
    });
    return config;
  };

  matchType = value => {
    let type;
    this.state.expendType.map(item => {
      if (item.value === value) {
        type = item.key;
        return item;
      }
      return type;
    });
    return type;
  };

  render() {
    const { isLoading, data, sum, groupName, year, sumAimData } = this.state;
    return (
      <div>
        <div>
          <Row>
            <Col span={8}>
              <span>预算部门：</span>
              <span>{groupName}</span>
            </Col>
            <Col span={8}>
              <span>预算周期：</span>
              {year ? <span>{year}年</span> : null}
            </Col>
            <Col span={8}>
              <span>预算总额：</span>
              <span>{util.numberFormat(sum, 2, '.', ',')}元</span>
            </Col>
          </Row>
        </div>
        {sumAimData.sumAim ? (
          <Card
            title={`目标收入：${util.numberFormat(sumAimData.sumAim)}`}
            style={{ marginTop: '20px' }}
          >
            {sumAimData.aims.length ? (
              <DescriptionList size="large" col={2}>
                {sumAimData.aims.map(item => {
                  return (
                    <Description term={() => this.findTypes(item.types)} key={item.uuid}>
                      {util.numberFormat(item.aim, 2, '.', ',')}
                    </Description>
                  );
                })}
              </DescriptionList>
            ) : (
              <span>暂无具体类目目标收入</span>
            )}
          </Card>
        ) : null}
        <div>
          <Table
            rowKey={record => record.index}
            columns={this.columns()}
            dataSource={data}
            pagination={false}
            loading={isLoading}
            style={{ marginTop: '20px' }}
            bordered
            size="small"
            scroll={{ x: 1800, y: util.pageHeight() - 120 }}
          />
        </div>
      </div>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/finance/budget/set/FormOpen.js